import { Code } from "./CrewInfo";
import { ExternalCrewInfo } from "./ExternalCrewInfo";

export class ExternalTripAccessDataResponse {
    firstAcess: boolean;
    hasAccess: boolean;
    blocked: boolean;
    requiresMfa: boolean;
    maskedEmail: string;
    accessDeniedMessage: string;
    externalCrew: ExternalCrewDTO;
    token: string;

    toCrewInfo(): ExternalCrewInfo {
        const code = new Code();
        code.type = 'anac-code';
        code.value = this.externalCrew.anacCode;
        const crewInfo = new ExternalCrewInfo();
        crewInfo.firstAccess = this.firstAcess;
        crewInfo.hasAccess = this.hasAccess;
        crewInfo.blocked = this.blocked;
        crewInfo.requiresMfa = this.requiresMfa;
        crewInfo.maskedEmail = this.maskedEmail;
        crewInfo.accessDeniedMessage = this.accessDeniedMessage;
        crewInfo.firstName = this.externalCrew.name.split(' ')[0];
        crewInfo.company = this.externalCrew.company;
        crewInfo.companyDomain = this.externalCrew.companyDomain;
        crewInfo.companyDomains = this.externalCrew.companyDomains ?? [];
        crewInfo.fullName = this.externalCrew.name;
        crewInfo.email = this.externalCrew.email;
        crewInfo.base = this.externalCrew.base;
        crewInfo.type = 'external-crew';
        crewInfo.code = code;
        return crewInfo;
    }
}

class ExternalCrewDTO {
    anacCode: string;
    licenceCode: string;
    cpfCode: string;
    crewId: string;
    name: string;
    base: string;
    company: string;
    companyDomain: string;
    companyDomains: string[];
    email: string;
    startDueDate: string;
    endDueDate: string;
}
